export default {
  type: 'Typ',
  relevanceNo: 'Numer zamówienia',
  consultContent: 'Treść konsultacji',
  submitTime: 'Czas wysłania',
  consultTypeEnum: {
    0: 'Zapytanie o zamówienie',
    1: 'Zapytanie o przesyłkę'
  },
  consultStatusEnum: {
    0: 'nieprzetworzone',
    1: 'w trakcie przetwarzania',
    2: 'zakończone'
  }
}